<template>
    <div class="page account-area">
        <div class="page-content">
            <div class="fixed-content container">
                <div class="tabs">
                    <div class="tab tab-active form-elements tabs">
                        <form class="tab tab-active" novalidate="" v-on:submit.prevent="submit">
                            <center>
                                <!-- <img src="static/images/logo.png" style="width: 20vh; min-width: 150px; margin-top: 30px; margin-bottom: 10px;"> -->
                                <img src="static/images/logo.png" style="width: 250px; margin-top: 30px; margin-bottom: 0px;">
                            </center>
                            <div class="title-head mt-15">
                                <h2 class="title text-align-center">
                                    Acesse sua conta
                                    <i class="las la-sign-in-alt"></i>
                                </h2>
                            </div>
                            <div class="list">
                                <ul class="row">
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label">E-mail</div>
                                            <div class="item-input-wrap">
                                                <input type="email" placeholder="Escreva seu e-mail" v-model="form.email" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content col-100 item-input">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Senha</div>
                                            <div class="item-input-wrap">
                                                <input type="password" v-model="form.senha" placeholder="Escreva sua senha" class="form-control input-senha"/>
                                                <a v-on:click="mostrarSenha" class="mostrar-senha">
                                                    <i class="las la-eye" v-if="!senha"></i>
                                                    <i class="las las la-eye-slash" v-if="senha"></i>
                                                </a>                                               
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <p class="form-text">
                                    <a class="tab-link" v-on:click="recuperarSenha">
                                        Esqueceu sua senha?
                                    </a>
                                </p>
                            </div>
                            <div class="clearfix">
                                <button type="submit" class="button-large button button-fill">
                                    ENTRAR
                                    <i class="las la-check-circle ml-10" style="line-height: 1.3; font-size: 24px;"></i>
                                </button>
                                <p class="line-divider">
                                    <span>
                                        Ou
                                    </span>
                                </p>
                                <router-link :to="{'name': 'Cadastro'}" class="link external button-large button button-fill button-gray">
                                    CADASTRE-SE
                                    <i class="las la-user-plus ml-10" style="line-height: 1.3; font-size: 24px;"></i>
                                </router-link>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>      
</template>

<script>
export default {
    name: 'Login',
    data () {
        return {
            senha:                  false,
            loading: {
                "recuperarSenha":   false,
                "submit":           false,
            },
            form: {
                "email":            "",
                "senha":            ""
            }
        }
    },
    methods: {
        mostrarSenha: function() {
            var self = this;
            self.senha = self.senha ? false : true;
            if (self.senha) {
                $('.input-senha').attr("type", "text");
            } else {
                $('.input-senha').attr("type", "password");
            }
            self.$forceUpdate();
        },            
        recuperarSenha: function(e) {
            var self            = this;
            console.log("recuperarSenha", e, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.recuperarSenha = true;
            loading.show();
            axios.post("api/recuperar-senha.php", self.form)
            .then(response => {
                loading.hide();
                self.loading.recuperarSenha = false;
                console.log("ok", response)
                alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.recuperarSenha = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        submit: function(e) {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form));
            loading.show();
            if (e) e.preventDefault();
            self.loading.submit = true;
            form.senha          = md5(form.senha);

            axios.post("api/login.php", form)
            .then(response => {

                console.log(">>>", response.data)
                // self.loading.submit = false;
                if (response.data.user) {
                    if (response.data.user.tipo != "admin" && response.data.user.tipo != "prestador" && response.data.user.tipo != "empresa") {
                        loading.hide();
                        alert("Esse acesso é destinado somente para profissionais e administradores do sistema.");
                        return false;
                    }

                    self.$root.setUser(response.data.user).then(function() {
                        // self.$router.push({"name": "Dashboard"});
                        setTimeout(function() {
                            location.reload();
                        }, 200);
                    });
                } else {
                    loading.hide();
                }
                // alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }        
    },
    mounted: function() {
        setTimeout(function() {
            loading.hide();
        }, 500);
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mostrar-senha {
        position: absolute;
        right: 18px;
        top: 12px;
        font-size: 22px;
    }   

    .account-area .title-head .title {
        margin-bottom: 15px;
    }

    .account-area .title-head .title {
        margin-bottom: 0px;
    }

    .line-divider {
        margin: 15px 0;
        position: relative;
    }

    .line-divider span {
        background-color: #ffffff;
        z-index: 1;
        text-align: center;
        display: inline-block;
        width: 100%;
    }

    .line-divider:before {
        content: "";
        width: 40%;
        height: 2px;
        background-color: var(--f7-theme-color-shade);
        position: absolute;
        top: 10px;
        left: 0px;
        z-index: 0;
    }

    .line-divider:after {
        content: "";
        width: 40%;
        height: 2px;
        background-color: var(--f7-theme-color-shade);
        position: absolute;
        top: 10px;
        right: 0px;
        z-index: 0;
    }

    .fixed-content {
        min-height: 100vh;
        /*height: 100vh;*/
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue